import {
  get,
  keys,
  isEmpty,
  has,
} from 'lodash';
import Mpo from './parse.mpo.json';
import Zenith from './parse.zenith.json';

export { default as Countries } from './countries.json';
export const Parsers = {
  ...Mpo,
  ...Zenith,
};

export const getPermission = (permissions, name) => permissions
  .filter(p => p.menu.url === ':permission')
  .find(p => p.menu.titleEN.toLowerCase() === name.toLowerCase());

/* eslint-disable */
export const uid = () => ('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx').replace(/[xy]/g, (c) => {
  const r = Math.random() * 16 | 0;
  const v = c === 'x' ? r : 0;
  return v.toString(16);
});

export const oftype = (any, match) => Object.prototype.toString
  .call(any)
  .match(match);

export const error = (err) => {
  let message = {};

  if (message = get(err, 'response.data.errors')) {
    return message;
  } else if (message = get(err, 'response.data')) {
    return message;
  } else if (message = get(err, 'response')) {
    return message;
  } else {
    return err;
  }
}

export const Parser = {
  /**
   * @param {Array} entries
   * @param {String} by
   */
  group(entries, by) {
    const grouped = { };

    if (!entries) return null;
    entries = oftype(entries, 'Object') ? [entries] : entries;
    if (entries.some(e => has(e, 'products'))) return entries;
    entries.map(e => {
      if (!e[by]) return;
      if (!grouped[e[by]]) grouped[e[by]] = { ...e, products: [] };
      grouped[e[by]].products.push(e);
    });

    return _(grouped).keys().map(k => grouped[k]).value();
  },

  /**
   * @param {Object} i
   * @param {Array} fields
   */
  combinated(i, fields) {
    const merge = [];
    fields.map((f) => { merge.push(i[f]) });
    return merge.filter(Boolean).join(' ');
  },

  /**
   * @param {Object} i
   * @param {String} sys
   */
  transObj(i, sys, j) {
    const item = { };
    if (get(sys, '_compress') && sys._compress.length) {
      sys._compress.map(c => {
        item[c._name] = { };
        keys(c).filter(k => !k.startsWith('_')).map(k => {
          if (oftype(c[k], 'String')) item[c._name][k] = get(i, c[k]);
          else item[c._name][k] = Parser.combinated(i, c[k]);
        });
      });
    }
    keys(sys).map((k) => {
      if (oftype(get(j, sys[k]._root), 'Object')) {
        item[k] = Parser.transObj(get(j, sys[k]._root), sys[k], j);
      } else if (oftype(get(j, sys[k]._root), 'Array')) {
        item[k] = Parser.transArr(get(j, sys[k]._root), sys[k], j);
      } else if (oftype(get(i, sys[k]._base), 'Object')) {
        item[k] = Parser.transObj(get(i, sys[k]._base), sys[k], j);
      } else if (oftype(get(i, sys[k]._base), 'Array')) {
        item[k] = Parser.transArr(get(i, sys[k]._base), sys[k], j);
      } else if (!k.startsWith('_') && ['Array', 'String'].some(t => oftype(sys[k], t))) {
        if (oftype(sys[k], 'String')) item[k] = get(i, sys[k]);
        else item[k] = Parser.combinated(i, sys[k]);
      } else {
        //
      }
    });

    return isEmpty(item) ? null : item;
  },

  /**
   * @param {Array} arr
   * @param {String} sys
   */
  transArr(arr, sys, j) {
    return arr.map((i) => {
      return Parser.transObj(i, sys, j);
    });
  },

  /**
   * @param {Array|Object} any
   * @param {String} system
   */
  map(any, system) {
    const sys = Parsers[system];
    if (oftype(any, 'Array')) return Parser.transArr(any, sys, any);
    if (oftype(any, 'Object')) return Parser.transObj(any, sys, any);
  },
};

export const allTrackingQuery = {
  search: `{
    "query": {
      "nested": {
        "path": "references",
        "query": {
          "bool": {
            "must": {
              "term": {
                "references.ref": "[_id]"
              }
            },
            "must_not": {
              "term": {
                "systemInitiated": true
              }
            }
          }
        }
      }
    }
  }`,
  /**
   * @param {String} type
   * @param {Array} params
   */
  generate(type, params = { }) {
    let query = this[type] || '';

    keys(params).map(k => {
      query = query.replace(`[${k}]`, params[k]);
    });

    return JSON.parse(query);
  },
};

/* eslint-enable */

/**
 * Storage
 * --
 * Simple wrap for localstorage using, prepends a prefix to avoid problemns with
 * other key/value items in the localstorage.
 */
export const Storage = {
  prefix: 'tt',
  get(key) {
    return window.localStorage.getItem(`${this.prefix}-${key}`);
  },
  set(key, value) {
    return window.localStorage.setItem(`${this.prefix}-${key}`, value);
  },
  rm(key) {
    return window.localStorage.removeItem(`${this.prefix}-${key}`);
  },
};
